import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)
export const setTabId = (tabId: string) => Cookies.set('tabId', tabId)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const getTabId = () => Cookies.get('tabId')
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'PZ-Token'
export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const removeToken = () => Cookies.remove(tokenKey)
